import CommonFunctions from "./CommonFunctions";
export default class DropDownPlus {
    static getPopupWindowResult() {
        return $(`#${DropDownPlus.dropDownPopupWindowIdStack[DropDownPlus.dropDownPlusWindowIndex]}`).data("popupWindowResult") || [];
    }
    // default result to value mapper
    static mapWindowResultToDropDownValue(windowResult) {
        if (windowResult && windowResult.length > 0) {
            //odata support ; always return array
            return windowResult.pop();
        }
        if (windowResult && typeof windowResult === "number") {
            //controller support, always return number
            return windowResult;
        }
        return undefined;
    }
    static openDropDownPlusWindow(url, title, dropDownId, resultToValueMapper = DropDownPlus.mapWindowResultToDropDownValue) {
        const deferred = jQuery.Deferred();
        DropDownPlus.dropDownPopupWindowIdStack.push(`dropDownPlusWindow${DropDownPlus.dropDownPlusWindowIndex++}`);
        const wnd = CommonFunctions.openInModalWindow(DropDownPlus.dropDownPopupWindowIdStack[DropDownPlus.dropDownPlusWindowIndex], url, title, true, null, 800);
        wnd.one("close", () => {
            const dropDown = $(`#${dropDownId}`).data().kendoDropDownList;
            const result = DropDownPlus.getPopupWindowResult();
            dropDown.dataSource.read().then(() => {
                const value = resultToValueMapper(result);
                if (value) {
                    dropDown.value(value);
                }
                deferred.resolve(result);
            }).fail(() => deferred.reject());
            DropDownPlus.dropDownPopupWindowIdStack.pop();
            DropDownPlus.dropDownPlusWindowIndex--;
        });
        return deferred;
    }
    static dropDownPlusButtonClickHandler(button, url, title, dropDownId, resultToValueMapper = DropDownPlus.mapWindowResultToDropDownValue) {
        button.enable(false);
        DropDownPlus.openDropDownPlusWindow(url, title, dropDownId, resultToValueMapper)
            .done(() => button.enable(true))
            .fail(() => console.error("openDropDownPlusWindow failed"));
    }
    static removeDataFromWindowResult(result) {
        const array = DropDownPlus.getPopupWindowResult().filter((item) => item !== result);
        $(`#${DropDownPlus.dropDownPopupWindowIdStack[DropDownPlus.dropDownPlusWindowIndex]}`).data("popupWindowResult", array);
    }
    static addDataToPopuWindowResult(result) {
        const array = DropDownPlus.getPopupWindowResult();
        array.push(result);
        $(`#${DropDownPlus.dropDownPopupWindowIdStack[DropDownPlus.dropDownPlusWindowIndex]}`).data("popupWindowResult", array);
    }
    static odataGridOnRequestEnd(e, valueField) {
        if (e.type === 'create') {
            DropDownPlus.addDataToPopuWindowResult(e.response[valueField]);
        }
        else if (e.type === 'destroy') {
            DropDownPlus.removeDataFromWindowResult(e.response.value);
        }
    }
}
DropDownPlus.dropDownPopupWindowIdStack = [];
DropDownPlus.dropDownPlusWindowIndex = -1;
